import { jsxs, jsx } from "react/jsx-runtime";
const IconGiftSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M21 6h-3.184c.112-.314.184-.648.184-1 0-1.654-1.346-3-3-3-1.395 0-2.363 1.101-3 2.259C11.363 3.1 10.395 2 9 2 7.346 2 6 3.346 6 5c0 .352.072.686.184 1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v7c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-7h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm-6-2a1 1 0 0 1 0 2h-1.61c.435-1.034 1.056-2 1.61-2ZM8 5a1 1 0 0 1 1-1c.554 0 1.175.966 1.61 2H9a1 1 0 0 1-1-1ZM4 8h7v2H4V8Zm2 11v-7h5v8H7a1 1 0 0 1-1-1Zm12 0a1 1 0 0 1-1 1h-4v-8h5v7Zm2-9h-7V8h7v2Z" })
    ]
  }
);
export {
  IconGiftSvg
};
